"use strict";

/**
 * Full page interstitial
 * @method FlixFpi.isEnabled()
 * @param FlixFpi.sessionAfterPopKey
 */
var FlixFpi = function () {
  /**
   * If script added and event listeners already initialized
   */
  var initialized = false;
  /**
   * Used to check if FPI script loaded (no adblock and stuff)
   * when calling FPI manually on the video/preroll page
   */
  var fpiLoaded = false;

  /**
   * Technically TR manages rate limits on they own. This ones used
   * during video/preroll clicks
   */
  var stopCookie = 'fpi_stop';
  var stopCookieMedia = 'fpi_stop_media';
  var sessionStopKey = 'fpi_session_stop';
  var sessionAfterPopKey = 'open_fpi_after_pop';

  /**
   * Initialize event handlers.
   * Called in the end to let this module fully load in to the memory first.
   */
  var init = function init() {
    document.addEventListener('flix:load', onPageLoad);
  };

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  var isEnabled = function isEnabled() {
    return Flix.ads.enabled
    /** We show either popunder or FPI, not both */ && !FlixPop.isEnabled()
    /** once per 12 hours for organic and on every visit for mediabuy */
    // && (
    //     Flix.ads.isOrganic()
    //         /** No fpi stop cookie for organic user */
    //         ? !FlixUtils.hasCookie(stopCookie)
    //         /** New session for mediabuy */
    //         : !FlixUtils.hasCookie(stopCookieMedia)
    // )
    /** Those mediabuys forbid fpi on TNA */ && (Flix.isTna()
    /** Those mediabuys forbid fpi on TNA */ ? [1, 8].indexOf(Flix.ads.iid) === -1 : true) && !(Flix.requireAgeVerification && !Flix.ageVerified);
  };

  /**
   * TwinRed FPI zone id. You can find it in the end of the URL string in FPI dashboard section
   * @returns integer
   */
  var getMobileZoneId = function getMobileZoneId() {
    if (Flix.isTna()) {
      return '01DXF6DT004000000000001ASY';
    } else {
      return '01DXF6DT004000000000001ASC';
    }
  };

  /**
   * TwinRed FPI zone id. You can find it in the end of the URL string in FPI dashboard section
   * @returns integer
   */
  var getDesktopZoneId = function getDesktopZoneId() {
    if (Flix.isTna()) {
      return '01DXF6DT0040000000000019H8';
    } else {
      return '01DXF6DT0040000000000019RQ';
    }
  };

  /**
   * Main logic
   */
  var onPageLoad = function onPageLoad() {
    var clicksCounter = FlixUtils.getCookie('fpi_clicks_counter') ? parseInt(FlixUtils.getCookie('fpi_clicks_counter')) : 0;
    FlixUtils.setCookie('fpi_clicks_counter', clicksCounter + 1, 1 / 2);
    var _triger = '#video-player-container';
    if (!isEnabled() || initialized) {
      return;
    }
    initialized = true;
    if (!document.querySelector('[data-tr-zone="' + getMobileZoneId() + '"]')) {
      var inMobile, insDesktop;
      inMobile = document.createElement('ins');
      inMobile.setAttribute('data-tr-zone', getMobileZoneId());
      inMobile.setAttribute('data-subid', Flix.ads.iid);
      inMobile.setAttribute('data-keywords', Flix.ads.tags);
      insDesktop = document.createElement('ins');
      insDesktop.setAttribute('data-tr-zone', getDesktopZoneId());
      insDesktop.setAttribute('data-subid', Flix.ads.iid);
      insDesktop.setAttribute('data-keywords', Flix.ads.tags);
      if (!Flix.ads.isOrganic()) {
        insDesktop.setAttribute('data-freq-hours', 0.1);
        inMobile.setAttribute('data-freq-hours', 0.1);
      }
      if (Flix.isTna()) {
        if (clicksCounter == 0) {
          if (!FlixUtils.isChrome()) {
            inMobile.setAttribute('data-trigger-element', _triger);
            // inMobile.setAttribute('data-trigger-excluded-element', "#prerollAdSkip, .plyr__volume");
            insDesktop.setAttribute('data-trigger-element', _triger);
            // insDesktop.setAttribute('data-trigger-excluded-element', "#prerollAdSkip, .plyr__volume");
          } else {
            inMobile.setAttribute('data-trigger-element', 'a');
            insDesktop.setAttribute('data-trigger-element', 'a');
          }
        }
        if (FlixUtils.isChrome()) {
          inMobile.setAttribute('data-trigger-excluded-element', "#prerollAdSkip, #video-player-container, .video-detail-controls, #user-top-menu, .img-gal, .no-ads");
          insDesktop.setAttribute('data-trigger-excluded-element', "#prerollAdSkip, #video-player-container, .video-detail-controls, #user-top-menu, .img-gal, .no-ads");
        }
        inMobile.addEventListener('render', function (e) {
          e.preventDefault();
          if (FlixUtils.isChrome()) {
            FlixVideo.pauseVideo();
          } else {
            FlixPreroll.afterSkip();
          }
          console.log('FPI: preroll RENDERED');
        });
        insDesktop.addEventListener('render', function (e) {
          e.preventDefault();
          if (FlixUtils.isChrome()) {
            FlixVideo.pauseVideo();
          } else {
            FlixPreroll.afterSkip();
          }
          console.log('FPI: preroll RENDERED desktop');
        });
      }
      var s = document.createElement('script');
      s.type = "text/javascript";
      s.src = "https://s.ad.twinrdengine.com/adlib.js";
      s.async = true;
      s.onerror = function () {
        return FlixStats.increment('ad_error_fpi');
      };
      document.body.appendChild(inMobile);
      document.body.appendChild(insDesktop);
      document.body.appendChild(s);
    }

    /** TwinRed callbacks before interstitial opened and when it's closed */
    window.InfPreInterstitialProcessCallback = InfPreInterstitialProcessCallback;
    window.InfPostInterstitialCallback = InfPostInterstitialCallback;
  };

  /**
   * Custom trigger FPI on video/preroll click. Also it's triggered on the links
   * with classes specified in TwinRed dashboard
   * @param {Event} e 
   */
  var _playerTriggerFPI = function playerTriggerFPI(e) {
    /** If FPi already has been triggered for example from the thumb link */
    if (!isEnabled()) {
      return;
    }
    /**
     * Change rules to trigger on any LINK, no matters if that link is a thumb or not
     */
    if (e.target.getAttribute('href') != '' && e.target.getAttribute('href') != null) {
      if (!e.target.getAttribute('data-method') && !e.target.getAttribute('data-modal') && !e.target.classList.contains('btn')) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        e.stopPropagation();
        localStorage.setItem('fpi_link_url', e.target.getAttribute('href'));

        /** Cleanup */
        document.removeEventListener('click', _playerTriggerFPI, true);
        triggerFpiIfEnabled();
      }
    } else {
      if (e.target.closest('#video-player-container')) {
        //only video player
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        e.stopPropagation();

        /** Cleanup */
        document.removeEventListener('click', _playerTriggerFPI, true);
        triggerFpiIfEnabled();
      }
    }
  };

  /**
   * Trigger Fpi if stop cookies are not set, etc
   */
  function triggerFpiIfEnabled() {
    /** If FPi already has been triggered for example from the thumb link */
    if (!isEnabled()) {
      return;
    }

    /** Send event that will open FPI */
    window.dispatchEvent(new CustomEvent('infShowInterstitial', {
      detail: {
        zoneId: FlixUtils.isMobile() ? getMobileZoneId() : getDesktopZoneId()
      }
    }));

    /** If FPI not trigger `InfPreInterstitialProcessCallback()` it means it's not being loaded  */
    setTimeout(function () {
      if (!fpiLoaded) {
        InfPostInterstitialCallback();
      }
    }, 300);
  }

  /**
   * Callback triggered by TwinRed before show interstitial.
   * We use it when manually open FPI on video/preroll click to check if FPI
   * script loaded on the page. If not, we just stat playing video/preroll
   * @param {CustomEvent} e 
   */
  var InfPreInterstitialProcessCallback = function InfPreInterstitialProcessCallback(e) {
    fpiLoaded = true;
  };

  /**
   * Callback triggered by TwinRed when interstitial closed after being shown.
   * We use it when manually open FPI on video/preroll click 
   * @param {Event} e 
   * @param {bool} isDisplayed 
   * @param {integer} zoneId 
   */
  var InfPostInterstitialCallback = function InfPostInterstitialCallback(e, isDisplayed, zoneId) {
    if (isDisplayed) {
      setStopCookie();
    }
    /** Play video or preroll if any of it is active (otherwise nothing will happen) */

    if (localStorage.getItem('fpi_link_url')) {
      window.location.href = localStorage.getItem('fpi_link_url');
      localStorage.removeItem('fpi_link_url');
    } else {
      FlixVideo.playVideo();
      FlixPreroll.play();
    }
  };

  /**
   * Set stop cookie and session storage key (for mediabuys)
   */
  function setStopCookie() {
    FlixUtils.setCookie(stopCookie, 1, 1 / 2);
    FlixUtils.setCookie(stopCookieMedia, 1, 1 / 24 / 10);
    sessionStorage.setItem(sessionStopKey, 1);
  }

  // Initialize stuff
  init();
  return {
    isEnabled: isEnabled,
    sessionAfterPopKey: sessionAfterPopKey,
    playerTriggerFPI: _playerTriggerFPI,
    triggerFpiIfEnabled: triggerFpiIfEnabled
  };
}();